module.exports = __webpack_public_path__ + "img/article_9_2.b8187130.png";